import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const versions = createQueryKeys('versions', {
  component: code => [code],
})

export type CountryKeys = inferQueryKeys<typeof versions>
